export const breakpointMedium = '992px';
export const breakpointSmall = '575px';
